import api from './apiConfig';

const BASE_URL = '/me/permissions';

/**
 * L'unico punto in cui il frontend chiede al backend cosa può fare (spec §2.2).
 *
 * Il path è `/me/permissions` e non `/api/me/permissions` perché `apiConfig` monta già
 * `${API_URL}${API_BASE_PATH}`, cioè `/v1`, come baseURL.
 */
const permissionService = {
  /**
   * Ruoli e permessi, senza la griglia risorse × azioni. È quella che `PermissionContext`
   * chiama a ogni bootstrap dell'applicazione, per ogni utente: `grid` resta a `false` (il
   * default lato backend) perché costruire la griglia lì sarebbe lavoro pagato da chi non
   * aprirà mai «I miei permessi». Non toccare la firma: il contesto la chiama così oggi.
   */
  getMyPermissions: async () => {
    const response = await api.get(BASE_URL);
    return response.data;
  },

  /**
   * Come sopra, ma con `resourceGroups` popolato (`?grid=true`). Solo la pagina «I miei
   * permessi» ne ha bisogno: è l'unico chiamante di questo metodo.
   */
  getMyPermissionsGrid: async () => {
    const response = await api.get(BASE_URL, { params: { grid: true } });
    return response.data;
  },
};

export default permissionService;
